/**
 * Arquivo de tradução 
 * Idioma: Inglês
 */
const message = {
    Home: 'Home',
    Atendimento: 'Support',
}
export default message